module.exports = __webpack_public_path__ + "img/add.e7441b6e.png";